import { type } from "@testing-library/user-event/dist/type";

export interface Person {
    id: string;
    firstName: string;
    lastName: string;
    preferences?: string | null;
  }
  
  export type StringType = {
    id: string;
    brand: string;
    name: string;
    gauge?: string;
    color?: string;
    material: Material;
    stiffness?: number;
    spinPotential?: number;
  };
  
  
  export interface Stringing {
    id: string;
    personId: string;
    mainsId: string;
    crossesId?: string | null;
    strungAt: Date;
    mainsTension: number;
    crossesTension?: number | null;
    feedback?: string;
    racquetId: string;
  }

  export interface Strings {
    stringType: StringType,
    tension: number;
  }

  export interface StringingEntry extends Stringing {
    person: Person;
    mains: StringType;
    crosses: StringType | null;
    racquet: Racquet | null;
  }
  

  export interface PersonFormData {
    firstName: string;
    lastName: string;
    preferences?: string;
  }

  export interface Racquet {
    id: string;
    brand: string;
    model: string;
  }
  
  export enum Material {
    SYNTHETIC = 'SYNTHETIC',
    GUT = 'GUT',
    MULTIFILAMENT = 'MULTIFILAMENT',
    POLYESTER = 'POLYESTER',
  }
  